import type { ComponentType, ReactNode } from "react";
import { Outlet } from "react-router-dom";

// In Next.js App Router, a `layout.tsx` file at any folder level wraps its
// children automatically and receives them via the `children` prop. In React
// Router, child routes render through `<Outlet />`. This adapter bridges the
// two so the existing Next.js layout components can be reused unmodified.

type LayoutProps = { children: ReactNode };

export function withLayout(Layout: ComponentType<LayoutProps>) {
  return function LayoutRoute() {
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  };
}
